/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N4Inputs */

const en_to_csv_ref_n4 = /** @type {(inputs: To_Csv_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serialized as JSON text, then quoted because that text contains quotes.`)
};

const ko_to_csv_ref_n4 = /** @type {(inputs: To_Csv_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 텍스트로 직렬화된 뒤, 그 텍스트에 따옴표가 있으므로 인용됩니다.`)
};

const ja_to_csv_ref_n4 = /** @type {(inputs: To_Csv_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON テキストとしてシリアライズされ、そのテキストに引用符があるので引用されます。`)
};

/**
* | output |
* | --- |
* | "Serialized as JSON text, then quoted because that text contains quotes." |
*
* @param {To_Csv_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n4 = /** @type {((inputs?: To_Csv_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n4(inputs)
	if (locale === "ko") return ko_to_csv_ref_n4(inputs)
	return ja_to_csv_ref_n4(inputs)
});